import React from "react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919904858858?text=Hi"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "28px",
        right: "28px",
        zIndex: 9999,
        backgroundColor: "#093A5B",
        borderRadius: "50%",
        width: "56px",
        height: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
        transition: "transform 0.2s, box-shadow 0.2s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,0.35)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.25)";
      }}
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="32"
        height="32"
        fill="white"
      >
        <path d="M16 2C8.268 2 2 8.268 2 16c0 2.493.65 4.833 1.784 6.865L2 30l7.347-1.764A13.94 13.94 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2zm0 25.5a11.44 11.44 0 0 1-5.83-1.594l-.418-.248-4.36 1.048 1.072-4.25-.273-.437A11.46 11.46 0 0 1 4.5 16C4.5 9.649 9.649 4.5 16 4.5S27.5 9.649 27.5 16 22.351 27.5 16 27.5zm6.29-8.61c-.344-.172-2.037-1.004-2.352-1.119-.316-.115-.547-.172-.777.172-.23.344-.893 1.119-1.095 1.35-.2.23-.402.258-.746.086-.344-.172-1.453-.535-2.767-1.707-1.023-.912-1.713-2.037-1.914-2.381-.2-.344-.021-.53.15-.701.155-.155.344-.402.516-.603.172-.2.23-.344.344-.574.115-.23.057-.43-.029-.603-.086-.172-.777-1.874-1.065-2.566-.28-.674-.565-.583-.777-.594l-.66-.011c-.23 0-.603.086-.918.43s-1.207 1.18-1.207 2.877 1.236 3.335 1.408 3.565c.172.23 2.433 3.714 5.896 5.207.824.355 1.467.568 1.969.727.827.263 1.58.226 2.174.137.663-.1 2.037-.833 2.323-1.636.287-.804.287-1.493.2-1.636-.086-.143-.316-.23-.66-.402z" />
      </svg>
    </a>
  );
}
